import {
  Popover as HeroPopover,
  PopoverContent as HeroPopoverContent,
  PopoverContentProps as HeroPopoverContentProps,
  PopoverTrigger as HeroPopoverTrigger,
  PopoverTriggerProps as HeroPopoverTriggerProps,
  PopoverProps as HeroUIPopoverProps,
} from "@heroui/react";

export type PopoverProps = HeroUIPopoverProps;
export type PopoverContentProps = HeroPopoverContentProps;
export type PopoverTriggerProps = HeroPopoverTriggerProps;

export function Popover({ ...props }: PopoverProps) {
  return <HeroPopover {...props} />;
}

Popover.displayName = "RecareUI.Popover";

export {
  HeroPopoverContent as PopoverContent,
  HeroPopoverTrigger as PopoverTrigger,
};
